module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "m-comment"
  }, [_c('h4', {
    staticClass: "m-bt"
  }, [_c('span', {
    staticClass: "u-tt"
  }, [_vm._v(_vm._s(_vm.blockTitle))])]), _vm._v(" "), _c('comment-block', {
    attrs: {
      "comments": _vm.comments
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24f60488!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comment-normal.vue
// module id = 840
// module chunks = 2